import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomerService } from '../../../services/customer.service';

@Component({
  selector: 'app-change-status-dialog',
  templateUrl: './change-status-dialog.component.html',
  styleUrls: ['./change-status-dialog.component.css']
})
export class ChangeStatusDialogComponent implements OnInit {

  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  constructor(
    private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: number,
      private customerService: CustomerService) { }

  ngOnInit() {
    console.log(this.data)
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onCloseConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.customerService.changeStatus(this.data)
    .subscribe(
      data => {
        this.api_success = 'Status changed Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.api_error = error.error;
      this.disableConfirmbtn = false;
      }
    );

  }

}
